module.exports = __webpack_public_path__ + "img/dian_bao.8d7abb60.png";